import get from 'lodash/get'
import each from 'lodash/each'
import startCase from 'lodash/startCase'
import moment from 'moment'

import axios from './axios'

import { servicingApi } from '../config'

export const getHubspotProperties = async email => {
  const res = await axios.get(`${servicingApi}/hubspot/contact/${email}`)
  return get(res, 'data.properties')
}

export const submitSignUpForm = data => {
  return axios.post(`${servicingApi}/hubspot/contact/submit_homevest_get_started_form`, data)
    .catch(console.warn)
}

export const updateHubspotContact = (update, email) => {
  const data = {
    properties: formatHubspotProperties(update),
    email
  }

  return axios.post(`${servicingApi}/hubspot/contact/update`, data)
    .catch(console.warn)
}

export const submitScheduleViewingRequestForm = data => {
  return axios.post(`${servicingApi}/hubspot/contact/submit_schedule_viewing_request_form`, data)
    .catch(console.warn)
}

const formatHubspotProperties = update => {
  const properties = []

  each(update, (value, key) => {
    if (transformToHubspotProperty[key]) {
      const [hubspotKey, transform] = transformToHubspotProperty[key]
      properties.push({
        property: hubspotKey,
        value: transform(value)
      })
    } else {
      properties.push({
        property: key,
        value
      })
    }
  })

  return properties
}

const transformToHubspotProperty = {
  income: [
    'what_is_your_approximate_household_income_',
    val => val
  ],
  movingDate: [
    'looking_to_buy_when_',
    val => moment.utc(val).startOf('d').valueOf()
  ],
  note: [
    'schedulenote',
    val => val
  ],
  hasCosigner: [
    'has_cosigner',
    val => val ? 'Yes' : 'No'
  ],
  interestedInBuying: [
    'interestedinbuying',
    val => startCase(val)
  ]
}
